import { Button, Form, Grid, Input } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { ManagementFilterFormValues, SizeManagementFilterFormField } from 'features/cms/components/type';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';


const { useBreakpoint } = Grid;

type ManagementFilterFormProps = {
  formId: string;
  handleFilter: (values: ManagementFilterFormValues) => void;
  initialValues: ManagementFilterFormValues;
  closeModal?: () => void;
};

export const SizeFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: ManagementFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<ManagementFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues })
  };

  const handleOnFinish = (values: ManagementFilterFormValues) => {
    handleFilter(values as any);
    closeModal?.();
  };

  return (
    <Form<ManagementFilterFormValues>
      id={formId}
      name={formId}
      form={form}
      layout='vertical'
      onFinish={handleOnFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper style={{width:'100%'}}>
        <StandardItemsWrapper style={{width:'100%'}}>
          <div className='invoice_list' style={{width:'100%'}}>
          <Form.Item<ManagementFilterFormValues>
            label={"Size"}
            name={SizeManagementFilterFormField.Size}
          >
            <Input placeholder={"Enter size"} />
          </Form.Item>
          {screens.lg && (
        <ContentFilters.ButtonsWrapper className='filter_btn'>
          <Button type='primary' htmlType='submit'>
            {t('events.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('events.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>

  
    </Form>
  );
};
